import { render, staticRenderFns } from "./ToggleVerifiedButton.vue?vue&type=template&id=3e52e597&"
import script from "./ToggleVerifiedButton.vue?vue&type=script&lang=js&"
export * from "./ToggleVerifiedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports